<svg
  width="255px"
  height="67px"
  viewBox="0 0 255 67"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <title>grande-maison-mobile</title>
  <g id="2-Mon-paiement,-mes-frais" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Mobile-animation-nuages" transform="translate(-239.000000, -2826.000000)" stroke-width="1.5">
      <g id="grande-maison-mobile" transform="translate(240.000000, 2827.000000)">
        <g *ngIf="!isIndicateurRisqueMoyenHaut" transform="translate(-43, 0)">
          <path
            fill="#FFF"
            fill-rule="nonzero"
            d="M2.3 63.2L2.3 1 64.2 0.8 64.2 25.7 95.3 25.7 95.3 63.1z"
            transform="translate(-185 -410) translate(114 371) translate(71 40.081) translate(54.952) translate(63.048)"
          />
          <g stroke="#666" stroke-width="1.5">
            <path
              fill="#E6E6E6"
              d="M8.7 19.6L58.1 19.6 58.1 9.6 8.7 9.6z"
              transform="translate(-185 -410) translate(114 371) translate(71 40.081) translate(54.952) translate(63.048) translate(0 1)"
            />
            <path
              stroke-linecap="square"
              d="M2.3 4.7L2.3 63M64 4.7L64 25.3"
              transform="translate(-185 -410) translate(114 371) translate(71 40.081) translate(54.952) translate(63.048) translate(0 1)"
            />
            <path
              d="M95.3 29.9L95.3 63"
              transform="translate(-185 -410) translate(114 371) translate(71 40.081) translate(54.952) translate(63.048) translate(0 1)"
            />
            <path
              fill="#E6E6E6"
              d="M32 25.3H97.9V29.9H32zM.1 0H66V4.6H.1zM8.7 52.4L19.7 52.4 19.7 23 8.7 23zM64.6 55L73.3 55 73.3 35.2 64.6 35.2zM46.2 41.5L55.8 41.5 55.8 35.2 46.2 35.2zM77.9 55L86.6 55 86.6 35.2 77.9 35.2z"
              transform="translate(-185 -410) translate(114 371) translate(71 40.081) translate(54.952) translate(63.048) translate(0 1)"
            />
            <path
              fill="#666"
              d="M46.2 63L46.2 41.5 55.8 41.5 55.8 63"
              transform="translate(-185 -410) translate(114 371) translate(71 40.081) translate(54.952) translate(63.048) translate(0 1)"
            />
            <path
              d="M35.5 29.9L35.5 63"
              transform="translate(-185 -410) translate(114 371) translate(71 40.081) translate(54.952) translate(63.048) translate(0 1)"
            />
          </g>
        </g>

        <g
          *ngIf="isIndicateurRisqueMoyenHaut"
          id="grande_maison-copy"
          transform="translate(20.000000, 0.000000)"
          stroke="#666666"
        >
          <polygon
            id="maison-risque-haut-mobile"
            points="118.1 0.1 118.1 24.7 161.6 24.7 161.6 64.1 7 64.1 7 25.7 54.1 25.7 54.1 0.1"
          ></polygon>
          <polyline id="path_0_mobile" points="118.1 24.7 118.1 0.1 54.1 0.1 54.1 63.7"></polyline>
          <polygon id="path_1_mobile" fill="#E6E6E6" points="60.6 19.4 111.7 19.4 111.7 9 60.6 9"></polygon>
          <polygon id="path_2_mobile" fill="#E6E6E6" points="60.6 52.8 71.8 52.8 71.8 24.7 60.6 24.7"></polygon>
          <polygon id="path_3_mobile" fill="#E6E6E6" points="144.7 56 153.5 56 153.5 35.1 144.7 35.1"></polygon>
          <polygon id="path_4_mobile" fill="#E6E6E6" points="118.1 56 127 56 127 35.1 118.1 35.1"></polygon>
          <polygon id="path_5_mobile" fill="#E6E6E6" points="131.8 56 140.7 56 140.7 35.1 131.8 35.1"></polygon>
          <polyline id="path_6_mobile" points="89.1 63.7 89.1 24.7 161.6 24.7 161.6 63.4"></polyline>
          <polyline id="path_7_mobile" points="7 64.1 7 25.7 53.7 25.7"></polyline>
          <g id="Group-1" transform="translate(14.000000, 35.000000)" fill="#666666">
            <polyline id="path_8_mobile" points="0.1 29.1 0.1 0.1 33.1 0.1 33.1 28.9"></polyline>
          </g>
          <g id="Group-2" transform="translate(99.000000, 35.000000)">
            <polygon id="path_9_mobile" fill="#E6E6E6" points="0.2 7.4 9.9 7.4 9.9 0.9 0.2 0.9"></polygon>
            <polyline id="path_10_mobile" fill="#666666" points="0.2 29.1 0.2 7.8 9.9 7.8 9.9 29.1"></polyline>
          </g>
        </g>

        <g id="tree-1" transform="translate(0, 28)">
          <g class="animated-tree" stroke="#00874E" stroke-width="1.5">
            <path
              d="M20,10.5 C20,16.3 15.5,21 10,21 C4.5,21 0,16.3 0,10.5 C0,4.7 4.5,0 10,0 C15.5,0 20,4.7 20,10.5 Z"
              fill="#DCF8E0"
            ></path>
            <path
              class="animated-tree-trunk"
              d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
            ></path>
            <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
          </g>
        </g>

        <g id="tree-2" transform="translate(188.811321, 27.70000)">
          <g class="animated-tree delay-1" stroke="#00874E" stroke-width="1.5">
            <path
              transform="translate(-1, -13)"
              d="M10.5,0.9 C14.7,0.9 18.1,4.3 18.1,8.5 C18.1,10.5 17.4,12.2 16.1,13.6 C19,15.5 21,18.7 21,22.5 C21,28.3 16.3,33 10.5,33 C4.7,33 0,28.2 0,22.4 C0,18.7 1.9,15.4 4.9,13.5 C3.7,12.2 2.9,10.4 2.9,8.4 C2.9,4.3 6.3,0.9 10.5,0.9 Z"
              fill="#DCF8E0"
            ></path>
            <path
              class="animated-tree-trunk delay-1"
              d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
            ></path>
            <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
          </g>
        </g>

        <g id="tree-3" transform="translate(213.603774, 27.70000)">
          <g class="animated-tree delay-7" stroke="#00874E" stroke-width="1.5">
            <path
              transform="translate(-2, -27)"
              d="M24,24.9 C24,38.2 18.6,48.9 12,48.9 C5.4,48.9 0,38.2 0,24.9 C0,11.6 5.4,0.9 12,0.9 C18.6,0.9 24,11.6 24,24.9 Z"
              fill="#DCF8E0"
            ></path>
            <path
              class="animated-tree-trunk delay-7"
              d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
            ></path>
            <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
